export default __webpack_public_path__ + "static/media/abjadiyat_lessons.c7de981e.png";